import { forwardRef } from 'react';

import { Container, type ContainerProps } from '@frontend/components';

import { PaneContextProvider, type PaneContextValue } from './context';
import { PaneWebSocketParam, usePaneWebSocket } from './usePaneWebSocket';

export type PaneProps = ContainerProps &
  PaneContextValue & {
    websocketOptions?: Partial<PaneWebSocketParam>;
  };

export const Pane = forwardRef<HTMLDivElement, PaneProps>(
  ({ refetchQueryKey, websocketOptions, ...props }, ref) => {
    const defaultWebsocketOptions = {
      topic: null,
      queryKeyOrInvalidator: refetchQueryKey,
    } satisfies PaneWebSocketParam;

    usePaneWebSocket({
      ...defaultWebsocketOptions,
      ...websocketOptions,
    });
    return (
      <PaneContextProvider refetchQueryKey={refetchQueryKey}>
        <Container
          size="lg"
          height="full"
          minHeight={35}
          ref={ref}
          {...props}
        />
      </PaneContextProvider>
    );
  },
);

Pane.displayName = 'Pane';
